import { Control } from "ol/control.js";
import Draw from "ol/interaction/Draw.js";
import { Circle as CircleStyle, Fill, Stroke, Style, Text } from "ol/style.js";
import { Vector as VectorSource } from "ol/source.js";
import { Vector as VectorLayer } from "ol/layer.js";

class Texto extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const button = document.createElement("button");
    const tipLabel =
      options.tipLabel !== undefined
        ? options.tipLabel
        : "Añadir texto al hacer click en el mapa";
    button.title = tipLabel;
    button.innerText = "T";

    const element = document.createElement("div");
    element.className = "texto-control ol-unselectable ol-control";
    element.appendChild(button);

    super({ element: element, target: options.target });
    this.vectorSource = new VectorSource();
    //  this.vectorLayer = new VectorLayer({
    //  source: this.vectorSource,
    // });
    this.draw = null;
    this.measureTooltipElement = null;
    this.helpTooltipElement = null;
    this.active = false;

    //agregado para poder desactivar global
    this.onActivate = options.onActivate;

    button.addEventListener("click", this.toggleMeasurement.bind(this), false);
  }

  toggleMeasurement() {
    if (!this.active) {
      // agregado para poder desactivar global
      if (this.onActivate) this.onActivate(this);
      this.getMap().addLayer(
        new VectorLayer({
          source: this.vectorSource,
        })
      );
      this.addInteraction();
      this.active = true;
      this.element.classList.add("activo");
    } else {
      //this.getMap().removeLayer(this.vectorLayer);
      this.getMap().removeInteraction(this.draw);
      this.element.classList.remove("activo");

      //this.vectorSource.clear();

      this.draw = null;

      this.active = false;
    }
  }

  addInteraction() {
    this.draw = new Draw({
      source: this.vectorSource,
      type: "Point",
      freehand: true,
    });

    this.getMap().addInteraction(this.draw);

    this.draw.on("drawend", (event) => {
      const texto = prompt("Ingresa el texto");
      if (!texto) return;

      //es la featire del recién dibujado
      const feature = event.feature;
      feature.setStyle(
        new Style({
          text: new Text({
            font: "18px sans-serif",
            text: texto,
            fill: new Fill({
              color: "black",
            }),
            stroke: new Stroke({
              color: "white",
              width: 3,
            }),
            offsetY: -15,
          }),
        })
      );
    });
    window.addEventListener("keydown", (e) => {
      if (e.code == "Escape") {
        console.log("escale");
        //this.getMap().removeLayer(this.vectorLayer);
        //this.getMap().removeInteraction(this.draw);
        //this.element.classList.remove("activo");

        //this.vectorSource.clear();
        //this.active = false;

        this.getMap().removeInteraction(this.draw);
        this.element.classList.remove("activo");
      }
    });
  }
  desactivar() {
    this.getMap().removeInteraction(this.draw);
    this.element.classList.remove("activo");
    this.active = false;
  }
}

export default Texto;
